import { computed } from "@vue/composition-api";
import useFindNeighbors from "./useFindNeighbors";
import annotations from "@/store/modules/annotations";

export default function useSnap() {
  const nodes = computed(() => annotations.getNodes);
  const { findHorizontalNeighbors, findVerticalNeighbors } = useFindNeighbors();

  /**
   * snap i to j
   * @param {number} i - index of node that snaps to j
   * @param {number} j - index of node that i snaps to
   */
  const snap = (i, j, config) => {
    const nodeI = nodes.value[i];
    const nodeJ = nodes.value[j];

    // decide which dimension to snap on
    const dx = Math.abs(nodeI.pos.cx - nodeJ.pos.cx);
    const dy = Math.abs(nodeI.pos.cy - nodeJ.pos.cy);
    if (dx < dy) {
      // if config 'line' is set, snap all
      if (config.line === true) {
        const neighbors = findHorizontalNeighbors(i);
        neighbors.forEach(index => {
          annotations.set({
            path: `nodes[${index}].pos.cx`,
            value: nodes.value[j].pos.cx
          });
        });
      }
      // snap self
      annotations.set({
        path: `nodes[${i}].pos.cx`,
        value: nodes.value[j].pos.cx
      });
    } else if (dy < dx) {
      // if config 'line' is set, snap all
      if (config.line === true) {
        const neighbors = findVerticalNeighbors(i);
        neighbors.forEach(index => {
          annotations.set({
            path: `nodes[${index}].pos.cy`,
            value: nodes.value[j].pos.cy
          });
        });
      }
      // snap self
      annotations.set({
        path: `nodes[${i}].pos.cy`,
        value: nodes.value[j].pos.cy
      });
    }
  };

  return {
    snap
  };
}
